// extracted by mini-css-extract-plugin
export default {"item":"AccountItem_item__Z7WOH","avatar":"AccountItem_avatar__ODv7g","displayName":"AccountItem_displayName__lYDjj","email":"AccountItem_email__YsC3y"};